<template>
  <div class="main">
    <!-- <van-uploader
      :after-read="afterRead"
      :max-size="10 * 1024 * 1024"
      @oversize="onOversize"
      @click-preview="click_preview"
      :max-count="count"
      accept=".bmp, .jpg, .jpeg, .png, .gif,.docx,.xlsx"
      :disabled="isDone"
      v-model="fileList"
      :show-upload="true"
    >
      <template> -->
         <img :src="dataUrl" alt="" style="width: 1rem;height: 1rem;" v-if="imgtype === 1 && dataUrl!=''">
         <img :src="dataUrl2" alt="" style="width: 1rem;height: 1rem;" v-if="imgtype === 2 && dataUrl2!=''">
         <img :src="dataUrl3" alt="" style="width: 1rem;height: 1rem;" v-if="imgtype === 3 && dataUrl3!=''">
         <img :src="dataUrl4" alt="" style="width: 1rem;height: 1rem;" v-if="imgtype === 4 && dataUrl4!=''">
         <img :src="dataUrl5" alt="" style="width: 1rem;height: 1rem;" v-if="imgtype === 5 && dataUrl5!=''">
         <img :src="dataUrl6" alt="" style="width: 1rem;height: 1rem;" v-if="imgtype === 6 && dataUrl6!=''">
         <img :src="dataUrl7" alt="" style="width: 1rem;height: 1rem;" v-if="imgtype === 7 && dataUrl7!=''">
         <img :src="dataUrl8" alt="" style="width: 1rem;height: 1rem;" v-if="imgtype === 8 && dataUrl8!=''">
        <div style="display: flex">
          <!-- <div style="width: 2.2rem; height: 2rem" v-if="imgtype == 1"></div> -->
          <div class="imgfather" v-if="imgtype !== 6 &&imgtype !== 7 && imgtype !== 8" @click="show = true">
            <div
              v-if="imgtype == 2 || imgtype == 4"
              style="margin-bottom: -0.3rem"
            >
              <span>身份证头像页</span>
            </div>
            <div
              v-if="imgtype == 3 || imgtype == 5"
              style="margin-bottom: -0.3rem"
            >
              <span>身份证国徽页</span>
            </div>
            <div class="imgtip">
              <img :src="imges" alt="" />
            </div>
            <van-button type="default">点击上传</van-button>
          </div>
          <div class="imgfather" v-if="imgtype === 6" @click="buttonClick('docx')">
             <div class="imgtip">
              <img src="@/assets/imgs/授权委托书.png" alt="" />
            </div>
            <van-button type="default">点击上传</van-button>
          </div>
          <div v-if="imgtype == 7 || imgtype == 8" style="display: flex" @click="buttonClick('xlsx')">
            <van-button type="default" class="btns">点击上传</van-button>
          </div>
          <div class="allps" v-if="imgtype == 1">
            <p>提示：</p>
            <p>1.请上传最新证件原件（彩色扫描件或数码照，如使用复印件请加盖公章上传）；</p>
            <p>2.支持jpg/jpeg/png/bmp格式；</p>
            <p>3.请使用像素大于600万像素的相机拍摄，控制2M以内；</p>
            <p>4.避免使用经微信信传输过的图片；</p>
          </div>
        </div>
      <!-- </template>
    </van-uploader> -->
      <!-- <van-cell is-link title="基础用法" @click="show = true" /> -->
      <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
  </div>
</template>
<script>
import uploadApi from "@/request/uploadApi";
import { getcamera,getPickFile} from "@/request/flutterBrid";
export default {
  created() {},
  props: {
    id: String,
    fileUrl: Array,
    type: Number,
    isDone: Boolean,
    securityType: String,
    imgtype: Number,
    value: String,
  },
  data() {
    return {
      dataUrl:'',
      dataUrl2:'',
      dataUrl3:'',
      dataUrl4:'',
      dataUrl5:'',
      dataUrl6:'',
      dataUrl7:'',
      dataUrl8:'',
      fileList: [],
      show:false,
      actions: [{ name: '相机' }, { name: '相册' }],
      count: 5,
      imges: "",
      download: {
        authorization: "",
      },
    };
  },
  watch: {
    fileUrl: {
      deep: true,
      immediate: true,
      handler() {
        this.fileList = this.fileUrl;
      },
    },
    imgtype() {},
  },
  mounted() {
    console.log(6666, this.imgtype);
    let data = this.imgtype;
    if (data == 1) {
      this.imges = require("@/assets/imgs/营业执照2.png");
    }
    if (data == 2) {
      this.imges = require("@/assets/imgs/身份证头像页.png");
    }
    if (data == 3) {
      this.imges = require("@/assets/imgs/身份证国徽页.png");
    }
    if (data == 4) {
      this.imges = require("@/assets/imgs/身份证头像页.png");
    }
    if (data == 5) {
      this.imges = require("@/assets/imgs/身份证国徽页.png");
    }
    if (data == 6) {
      this.imges = require("@/assets/imgs/授权委托书.png");
      // this.download.authorization =
      //   "/s999/importTemplate/chemicals/电子销售系统（化工品销售）注册及管理授权书.docx";
      console.log(this.download.authorization);
    }
    if (data == 7) {
      // this.imges = require("@/assets/imgs/授权委托.png");
      // this.download.authorization =
      //   "/s999/importTemplate/chemicals/开票资料.xlsx";
      console.log(this.download.authorization);
    }
    if (data == 8) {
      // this.imges = require("@/assets/imgs/授权委托.png");
      // this.download.authorization =
      //   "/s999/importTemplate/chemicals/企业简介.docx";
      console.log(this.download.authorization);
    }
  },
  methods: {
     buttonClick(val) {
      console.log(val);
      let value = this.imgtype === 8?'docx':val;
      getPickFile(value,(result) => {
          //  console.log('pickFile调用',result);
           let data = JSON.parse(result);
           console.log('pickFile每个数据',data.fileData,data.fileName);
           this.afterRead(data);
      });
    },
    onSelect(val) {
      console.log(33333,val);
      let str = val.name === '相机'?'1':'2';
      console.log(str);
      // this.$router.push({
      //   path:"/renew",
      // });
      this.show = false;
      getcamera(str,
         (result) => {
           console.log('getcamera调用',result);
          //  this.dataUrl = result;
           console.log('dataUrl',this.dataUrl);
           this.afterRead(result);
          if (this.imgtype === 1) {
              this.dataUrl = result;
          }
          if (this.imgtype ===  2) {
              this.dataUrl2 = result;
          }
          if (this.imgtype === 3) {
              this.dataUrl3 = result;
          }
          if (this.imgtype ===  4) {
             this.dataUrl4 = result;
          }
          if (this.imgtype ===  5) {
              this.dataUrl5 = result;
          }
          if (this.imgtype ===  6) {
              this.dataUrl6 = result;
          }
         if (this.imgtype ===  7) {
          this.dataUrl7 = result;
         }
         if (this.imgtype ===  8) {
          this.dataUrl8 = result;
         }
      });
    },
    // 文件超过大小
    onOversize(file) {
      console.log(file);
      this.$toast("文件大小不能超过 10M");
    },
    /**文件上传 */
    async afterRead(file) {
      console.log("file", file);
      // let that = this;
      //   params.append("file", file);
      //   params.append("id", this.id);
      //   params.append("securityType", "private")
      function dataURLtoFile(dataurl, filename) {
        //将base64转换为文件
        var arr = dataurl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      }
      // console.log("JJFJFJJ", new File(file));
      let uploadFile = null;
      if(file.fileData) {
        uploadFile = dataURLtoFile(file.fileData, file.fileName)
      } else {
         uploadFile = dataURLtoFile(file, '.jpg')
      }
      // let uploadFile = file.fileData?dataURLtoFile(file, '.jpg'):dataURLtoFile(file.fileData, file.fileName);
      let formdata = new FormData();
      formdata.append("file", uploadFile); // 文件对象
      console.log(555, formdata);
      let config = {
        headers: {
          //添加请求头
          "Content-Type": "multipart/form-data",
          token: window.localStorage.getItem("Authorization"),
        },
      };
      //   return new Promise((resolve, reject) => {
      //     // if (file.type !== "image/*") {
      //     //   this.$toast("请上传 jpg 格式图片");
      //     //   reject();
      //     // } else {
      //       uploadApi.file(params, config).then((res) => {
      //         console.log(res, "vvvv");
      //         that.fileList = res.result;
      //         if (res.result.returnCode == "0") {
      //           //如果为真 resolve出去
      //           resolve(res.result);
      //         } else {
      //           //否则 Toast 提示
      //           this.$toast.fail(res.returnMessage);
      //           reject(res.returnMessage);
      //         }
      //       });
      //       //   resolve(img);
      //     // }
      //   });
      uploadApi.file(formdata, config).then((res) => {
        if (res.returnCode == "0") {
          console.log(222, res.result);
          // that.fileList[0] = res.result.imageUrl;
          this.$emit("input", res.result.imageUrl);
          this.$toast("上传成功");
          this.$emit("on-success", res.result.imageUrl,res.result.fileName);
        } else {
          //否则 Toast 提示
          this.$toast.fail(res.returnMessage);
        }
      });
    },
    /**文件删除 */
    beforeDelete(file, detail) {
      console.log(file, detail);
    },
    /* 文件下载 */
    click_preview(file) {
      console.log(file);
      //   if(file.fileid) {
      //     // 第一次上传，预览下载
      //     window.open(
      //       `${api.api_base}/system/file/downloadFile?id=${file.fileid}`
      //     );
      //   } else {
      //     window.open(`${api.api_base}/system/file/downloadFile?id=${file.id}`);
      //   }
    },
  },
};
</script>
<style scoped>
.main /deep/ .van-popup {
  height: 10% !important;
}
.main /deep/ .van-action-sheet__item {
  line-height: 0.42rem !important;
  margin-top: 0.1rem;
  font-size: 0.3rem !important;
}
.btns {
  width: 2rem;
  height: 0.85rem;
}

.allps {
  font-size: 0.22rem;
  color: #f0603b;
  margin-left: 0.1rem;
}
p {
  margin-bottom: 0.08rem;
}
.imgtip {
  width: 1rem;
  height: 1rem;
  border-radius: 1.5rem;
  border-radius: 1.5rem;
  margin: 0.2rem 0.4rem;
}
.imgfather {
  width: 1.8rem;
  height: 1.8rem;
  border: 0.04rem dashed #f0f8fa;
  text-align: center;
  margin-bottom: 0.5rem;
}
img {
  width: 0.8rem;
  height: 0.8rem;
  margin: 0.1rem;
}
</style>